module.exports = __webpack_public_path__ + "img/2_81.9da868b2.png";